import React from 'react';
import { Typography } from 'antd';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/Layouts/Layout';
import LandingLayout from '../../components/Layouts/LandingLayout';
import BackButton from '../../components/BackButton';
import NotFound from '../NotFound/NotFound';
import { useAuth } from '../../contextProviders/AuthProvider';
import { INFO_PAGES } from '../../constants/infoPages';
import { translate } from '../../helpers/translationHelper';

const { Title, Paragraph } = Typography;

/**
 * Generic renderer for every placeholder content page linked from
 * SiteFooter (help center, safety, about us, etc.) -- one reusable page
 * driven by constants/infoPages.ts instead of a file per link, since
 * they're all the same shape (title + a couple of paragraphs). Reachable
 * signed in or signed out.
 */
const InfoPage: React.FC = () => {
  const { t } = useTranslation();
  const { slug } = useParams<{ slug: string }>();
  const { isAuthenticated, loading: authLoading } = useAuth();

  const content = slug ? INFO_PAGES[slug] : undefined;
  if (!content) return <NotFound />;

  const page = (
    <div style={{ maxWidth: 640, width: '100%', textAlign: 'left' }}>
      <BackButton fallbackPath="/" />
      <Title level={3} style={{ marginTop: 12 }}>
        {translate(t, content.titleKey)}
      </Title>
      {content.bodyKeys.map((bodyKey) => (
        <Paragraph key={bodyKey}>{translate(t, bodyKey)}</Paragraph>
      ))}
    </div>
  );

  if (authLoading) return null;
  if (isAuthenticated) return <AppLayout>{page}</AppLayout>;
  return <LandingLayout>{page}</LandingLayout>;
};

export default InfoPage;
